import axios from 'axios';

export const ServiceConfigCloudRun = axios.create({
  baseURL:
    process.env.VUE_APP_ENDPOINT_WS_CLOUDRUN ||
    process.env.VUE_APP_ENDPOINT_WS,
});
